module.exports = __webpack_public_path__ + "static/img/3s-platform-img6.4f6a527.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-platform-img6.png
// module id = qqJh
// module chunks = 0